import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { withStyles } from '../../tools/withStyles';
import { withSounds } from '../../tools/withSounds';
import { withLanguage } from '../../tools/withLanguage';

const styles = theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 10px',
    borderRadius: 12,
    background: 'rgba(255, 255, 255, 0.03)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
    backdropFilter: 'blur(6px)',
    color: theme.color.heading.main
  },
  button: {
    background: 'transparent',
    border: 'none',
    color: 'inherit',
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 1,
    padding: '4px 8px',
    textTransform: 'uppercase',
    transition: 'color 180ms ease, transform 180ms ease',
    '&:hover, &:focus': {
      color: theme.color.tertiary.main,
      outline: 'none',
      transform: 'translateY(-1px)'
    }
  },
  active: {
    color: theme.color.tertiary.main
  },
  divider: {
    opacity: 0.5,
    padding: '0 6px',
    fontWeight: 700,
    fontSize: 12
  }
});

const LanguageSwitcherComponent = ({
  classes,
  className,
  language,
  setLanguage,
  sounds,
  t
}) => {
  const handleChange = lang => {
    if (lang === language) return;
    if (sounds && sounds.click) {
      sounds.click.play();
    }
    setLanguage && setLanguage(lang);
  };

  return (
    <div
      className={cx(classes.root, className)}
      role='group'
      aria-label={t('languageSwitcher.ariaLabel')}
    >
      <button
        type='button'
        className={cx(classes.button, language === 'en' && classes.active)}
        onClick={() => handleChange('en')}
        aria-pressed={language === 'en'}
      >
        {t('languageSwitcher.en')}
      </button>
      <span className={classes.divider}>|</span>
      <button
        type='button'
        className={cx(classes.button, language === 'es' && classes.active)}
        onClick={() => handleChange('es')}
        aria-pressed={language === 'es'}
      >
        {t('languageSwitcher.es')}
      </button>
    </div>
  );
};

LanguageSwitcherComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.any,
  language: PropTypes.string,
  setLanguage: PropTypes.func,
  sounds: PropTypes.object,
  t: PropTypes.func
};

const LanguageSwitcher = withStyles(styles)(withSounds()(withLanguage()(LanguageSwitcherComponent)));

export { LanguageSwitcher };
